import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { IMultilingualSideEffects } from '../types'
import { name } from '../symbols'
import { ITpaSrcUtility, TpaSrcUtilitySymbol } from 'feature-tpa-commons'
import { FeatureExportsSymbol } from '@wix/thunderbolt-symbols'
import { IFeatureExportsStore } from 'thunderbolt-feature-exports'

export const MultilingualSideEffects = withDependencies(
	[named(FeatureExportsSymbol, name), TpaSrcUtilitySymbol],
	(
		multilingualExports: IFeatureExportsStore<typeof name>,
		{ rebuildTpasSrc }: ITpaSrcUtility
	): IModelUpdatesHandlersImplementor<IMultilingualSideEffects> => ({
		featureName: name,
		handlers: {
			onLanguageChange({ languageCode }) {
				if (languageCode) {
					rebuildTpasSrc()
				}
			},
			onSiteConfigChange({ siteLanguages, currentLanguage, originalLanguage }) {
				multilingualExports.export({
					originalLanguageCode: originalLanguage.languageCode,
					siteLanguages,
					currentLanguage,
				})
			},
		},
	})
)
